export const pushDLActionVideo = (videoName, action, origin) => {
    console.log("EVENT VIDEO : ", { videoName, action });
    const componentName = {
        'landing': 'bees_luchodiaz_home',
        'user_zone': 'bees_luchodiaz_videosuccess',
        'internal': 'bees_luchodiaz_videosuccess'
    };
    window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Video',
        'event_action': action,
        'event_label': `${videoName}`,
        'interaction': 'true',
        'component_name': componentName[origin]
    });
};
